import { render } from "./EmployeesComp.vue?vue&type=template&id=1bf78d38&scoped=true"
import script from "./EmployeesComp.vue?vue&type=script&lang=js"
export * from "./EmployeesComp.vue?vue&type=script&lang=js"

import "./EmployeesComp.vue?vue&type=style&index=0&id=1bf78d38&scoped=true&lang=css"

import exportComponent from "E:\\coding\\pharaoh_frog_barber\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bf78d38"]])

export default __exports__